<template>
	<div>
		<v-toolbar app flat dark color="primary" class="map-toolbar" :class="{'is-inverted' : mapType != 'roadmap'}">
			<v-btn icon @click="gotoList()">
				<v-icon>list</v-icon>
			</v-btn>
			<v-toolbar-title>
				Mijn E-finders
				<span class="v-toolbar__subtitle" v-if="devices.length > 0">Kies een E-finder voor meer details</span>
			</v-toolbar-title>
			<v-btn icon @click="goToNotifications()">
				<v-icon>
					notifications
				</v-icon>
				<span v-if="unreadNotificationCount > 0" class="new-notifications"></span>
			</v-btn>
			<v-btn icon @click="showMenu()">
				<v-icon>menu</v-icon>
			</v-btn>
		</v-toolbar>

		<v-dialog v-model="activatedDialog" max-width="360">
			<v-card>
				<v-card-title class="headline">Je E-finder is geactiveerd!</v-card-title>
				<v-card-text>
					Let op het kan 1-2 uur duren voordat je bericht krijgt. Laat je E-finder aan de stroom om hem volledig deze volledig op te laden.
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="green darken-1" flat @click="hideActivatedDialog()">Ok</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<uf-drawer :expanded="showList" v-if="this.hasDevices" :class="{'is-inverted' : mapType != 'roadmap'}"
				   @close="listClosed()" ref="drawer">

			<v-layout slot="above" justify-space-between>
				<v-btn absolute fab right style="bottom: 100%;" class="mb-4" @click="toggleMapType">
					<v-icon>{{ mapType === 'roadmap' ? 'satellite' : 'map' }}</v-icon>
				</v-btn>
			</v-layout>

			<v-list two-line>

				<template v-for="device in list">
					<v-list-tile
						avatar
						:ripple="!!device.getState()"
						:key="device.id"
						@click="gotoDevice(device)"
						class="e-connectz_list-tile"
						:class="{
							'is-unregistered': !device.is_registered,
							'is-unactivated': device.isWaitingForActivation()
						}">
						<v-list-tile-avatar>
							<v-badge color="blue" v-if="device.isWaitingForActivation()">
								<template v-slot:badge>
									<span>!</span>
								</template>
								<i class="e-finder-icons">{{ device.getIcon() }}</i>
							</v-badge>
							<i class="e-finder-icons" v-else>{{ device.getIcon() }}</i>
						</v-list-tile-avatar>
						<v-list-tile-content>
							<v-list-tile-title>{{ device.name }}</v-list-tile-title>
							<v-list-tile-sub-title>{{ device.getSubtitle() }}</v-list-tile-sub-title>
						</v-list-tile-content>
						<v-list-tile-action v-if="device.getState()">
							<v-btn icon>
								<v-icon color="grey lighten-1">chevron_right</v-icon>
							</v-btn>
						</v-list-tile-action>
					</v-list-tile>
					<v-divider :key="'divider-' + device.id"></v-divider>
				</template>

			</v-list>
		</uf-drawer>

	</div>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex';

  export default {
    computed: {
      activatedDialog(){
        return this.$store.state.devices.activatedDialog;
	  },
      ...mapGetters(['unreadNotificationCount']),
      clusterListDevices() {
        return this.$store.state.cluster.clusterList;
      },
      devices() {
        return this.$store.getters.devices.sort(
          // Sort array of objects by boolean properties:
          // https://stackoverflow.com/questions/41104829/how-to-sort-array-of-objects-by-its-boolean-properties/41105161
          (a, b) =>
            b.isWaitingForActivation() - a.isWaitingForActivation()
            || !!b.activated_at - !!a.activated_at
        );
      },
      hasDevices() {
        return this.devices.length > 0;
      },
      mapType() {
        return this.$store.state.map.mapTypeId;
      },
    },
    watch: {
      clusterListDevices(value) {
        if (!value || value.length === 0) {
          this.list = this.devices;

          this.$nextTick(() => {
            if (this.$refs.drawer) this.$refs.drawer.measure();
          });
          return;
        }

        this.list = value;

        this.$nextTick(() => {
          if (this.$refs.drawer) this.$refs.drawer.measure();
          this.showList = true;
        });
      },
      devices(value) {
        if (this.clusterListDevices && this.clusterListDevices.length > 0) return;
        this.list = value;

        this.$nextTick(() => {
          if (this.$refs.drawer) this.$refs.drawer.measure();
        });
      },
    },
    data: () => ({
      list: [],
      showList: false,
    }),
    methods: {
      ...mapMutations(['hideActivatedDialog']),
      loadDevices() {
        this.$store.dispatch('loadDevices');
      },
      toggleShowList() {
        this.showList = !this.showList;
      },
      gotoList() {
        return this.$router.push({ name: 'devices.list' });
      },
      gotoDevice(device) {
        if (device.isWaitingForActivation()) {
          return this.$router.push({ name: 'devices.activate', params: { id: device.id } });
        }

        if (!device.getState()) return;

        this.$router.push({ name: 'devices.show', params: { id: device.id } });
      },
      goToNotifications() {
        this.$router.push('/notifications');
      },
      showMenu() {
        this.$store.dispatch('toggleMainMenu');
      },
      toggleMapType() {
        this.$store.dispatch('toggleMapType');
      },
      listClosed() {
        this.showList = false;
        this.$store.dispatch('unloadClusterList');
      },
      onAndroidBack(e) {
        if (this.$route.params.name === 'devices.index') {
          e.preventDefault();
        }
      }
    },
    created() {
      this.$store.dispatch('deselectDevice', this.$route.params.id);
      this.$store.dispatch('loadDevices');
      this.$store.dispatch('loadUnreadNotificationCount');
    },
    mounted() {
      document.addEventListener('backbutton', this.onAndroidBack, false);
    },
    beforeDestroy() {
      document.removeEventListener('backbutton', this.onAndroidBack);
    }
  };
</script>

<style lang="stylus">

	.new-notifications
		position: relative

		&:after
			content: ''
			opacity: 1
			z-index: 9999
			position: absolute
			display: block
			bottom: 0
			right: 0
			border-radius: 50%
			background-color: #FF0000
			height: 10px
			width: 10px

	.e-connectz_list-tile.is-unregistered
		filter: grayscale(75%)
		position: relative

		&:after
			content: ''
			position: absolute
			display: block
			top: 0
			left: 0
			width: 100%
			height: 100%
			background-color: rgba(#fff, .5)

	.e-connectz_add-tile .v-avatar
		position: relative

		&:after
			content: ''
			display: block
			position: absolute
			border: solid 2px #455B63
			top: 0
			left: 0
			right: 0
			bottom: 0
			border-radius: 50%

	.e-connectz_list-tile.is-unactivated .v-avatar
		.v-badge
			z-index: 1

		&:after
			border: solid 2px #455B63

	.e-connectz_list-tile .v-avatar
		position: relative

		&:after
			content: ''
			display: block
			position: absolute
			border: solid 4px orange
			top: 0
			left: 0
			right: 0
			bottom: 0
			border-radius: 50%

	.e-connectz_card-title .v-list__tile
		padding: 0

</style>
